import { useUserStore } from "~/store/user-store";
import UserModel from "~~/models/UserModel";
import { useProspectStore } from "~~/store/prospect-store";
import { LocalStorageConst } from "~~/consts/LocalStorage";

export const useUser = () => {
  let userStore = useUserStore();
  let prospectStore = useProspectStore();
  const localePath = useLocalePath();

  const getUserIsLoggedIn = async () => {
    await userStore.isLoggedIn();
    return userStore.userIsLoggedIn;
  };

  const loadUserInformation = async () => {
    await userStore.loadUserInformation();
  };

  const getUserInformation = (): UserModel => {
    return userStore.getUserInformation;
  };

  const requestForNewToken = async function (
    email: string,
    captchaToken: string
  ) {
    return userStore.requestForNewToken(email, captchaToken);
  };

  const requestForJWTToken = async function (accessTokenKey: string) {
    await userStore.requestForJWTToken(accessTokenKey);
    const jwtToken = userStore.getJwtToken;
    if (jwtToken) {
      localStorage.setItem(LocalStorageConst.TOKEN, jwtToken);
      await useUser().loadUserInformation();
      await navigateTo(localePath("/") + "/");
    } else {
      await useUser().logout();
    }
  };

  const getHeadersWithToken = async function () {
    const token = useLocalStorage(LocalStorageConst.TOKEN, null);
    let headers = useRequestHeaders();

    headers["Authorization"] = "Bearer " + token.value;

    return headers;
  };

  const logout = async function () {
    await userStore.logout();
    prospectStore.clear();
  };

  return {
    getUserIsLoggedIn,
    loadUserInformation,
    getUserInformation,
    requestForNewToken,
    requestForJWTToken,
    getHeadersWithToken,
    logout,
  };
};
